import { useCallback, useSyncExternalStore } from 'react';
import { ContentAudience } from '@amzn/awscat-pattern-library-service-model';

import { useContentEditorService } from '../../contexts/ContentEditorServiceContext';

/** Subscribes to the content editor service and returns the latest audience. */
export function useAudience(): ContentAudience | undefined {
  const service = useContentEditorService();

  // When the service emits 'changed', then re-read the audience.
  const subscribe = useCallback(
    (onStoreChange: () => void) => service.on('changed', onStoreChange),
    [service],
  );
  return useSyncExternalStore(subscribe, () => service.audience);
}
